import React from "react";
import {ChakraProps} from "@chakra-ui/system/dist/types/system.types";
import {Text} from "@chakra-ui/react";

export const Paragraph: React.FC<ChakraProps> = (props) => <Text as="p" my=".5em" {...props} />